import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";
console.log("baseUrlbaseUrl",baseUrl)
// Get products
export const getMotorsList = createAsyncThunk("/getMotorList", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}motors/api/v1/list`, data || {}, {
     headers: {
  "Content-Type": "application/json",
}
    });
    console.log("re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching Motors", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Motors");
  }
});